import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/loginusuario",

        async subAccountSearch({ id }) {
            const url = this.userUrl({
                path: `/${id}/local/open`
            });

            return Vue.http.get(url);
        },

        async assignNode({ id, nodeId, type }) {
            const url = this.userUrl({ path: `/${id}/local/` });

            return Vue.http.post(url, {
                nodeId,
                type
            });
        }
    },
    base
);
